export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    // GAME_SUSPENDED_MESSAGE: 'Game {0} is currently suspended...',  {0} = game name EXAMPLE WITH WILD CARD market types
    WIN_DRAW_WIN: 'Match Result',
    CORRECT_SCORE: 'Correct Score',
    TOTAL_GOALS: 'Total Goals',
    DOUBLE_CHANCE: 'Double Chance',
    UNDER_OVER: 'Over/Under',
    UNDER_OVER_25: 'Over/Under 2.5',
    UNDER_OVER_25_INITIALS: 'O/U 2.5',
    UNDER_OVER_35_INITIALS: 'O/U 3.5',
    UNDER_OVER_15: 'Over/Under 1.5',
    ASIAN_HANDICAP: 'Asian Handicap',
    HANDICAP: '1X2 Handicap',
    HANDICAP_FIRST: '1X2 Handicap Home +1',
    HANDICAP_SECOND: '1X2 Handicap Away +1',
    UNDER_OVER_05: 'Under/Over 0.5',
    UNDER_OVER_35: 'Over/Under 3.5',
    BOTH_TEAMS_SCORE: 'Both Teams To Score',
    BOTH_TEAMS_SCORE_INITIALS: 'BTTS',
    HOME_TEAM_GOALS: '{0} Team Goals',
    AWAY_TEAM_GOALS: '{1} Team Goals',
    MATCH_BETTING_BOTH_TEAMS_SCORE: 'Match Betting Both Teams Score',
    WINNING_MARGIN: 'Winning Margin',
    CORRECT_SCORE_GROUP: 'Correct Score Group',
    HOME_TEAM_TO_SCORE: '{0} To Score',
    AWAY_TEAM_TO_SCORE: '{1} To Score',
    FIRST_TEAM_TO_SCORE: 'First Team To Score',
    LAST_TEAM_TO_SCORE: 'Last Team To Score',
    HALF_TIME_FULL_TIME: 'Half Time Full Time',
    TEAM_SCORECAST: 'Team Scorecast',
    HALF_TIME_CORRECT_SCORE: 'Half Time Correct Score',
    HALF_TIME_RESULT: 'Half Time Result',
    FIRST_LAST_TO_SCORE: 'First / Last to Score',
    LAST: 'Last',
    FIRST: 'First',
    IN: 'in',
    LAST_THREE_GAMES: 'Last 3 Games',
    PREVIOUS: 'Previous',
    EIGHT_RESULTS: '8 Matches',
    EIGHT_GAMES: '8 Games',
    OVER_25: 'Over 2.5',
    UNDER_25: 'Under 2.5',
    OVER_35: 'Over 3.5',
    UNDER_35: 'Under 3.5',
    COVERED: 'Covered',
    DID_NOT_COVER: 'Did Not Cover',
    SPREAD: 'Spread',
    TOTAL_POINTS_UNDER_OVER: 'Total Points Under/Over',
    TOTAL_POINTS_OVER_UNDER: 'Total Points Over/Under',
    MONEYLINE: 'Money Line',
    TOTAL_POINTS_GROUP: 'Total points group',
    MONEY_LINE_TOTAL_POINTS: 'Money Line & Total Points O/U',
    SPREAD_TOTAL_POINTS: 'Spread & Total Points O/U',
    // countries (these are lowecase and strings on purpose)
    'Argentina': 'Argentina',
    'Belgium': 'Belgium',
    'Brazil': 'Brazil',
    'Colombia': 'Colombia',
    'Costa Rica': 'Costa Rica',
    'Croatia': 'Croatia',
    'Czech Republic': 'Czech Republic',
    'Denmark': 'Denmark',
    'Egypt': 'Egypt',
    'England': 'England',
    'France': 'France',
    'Germany': 'Germany',
    'Greece': 'Greece',
    'Holland': 'Holland',
    'Iceland': 'Iceland',
    'Italy': 'Italy',
    'Mexico': 'Mexico',
    'Poland': 'Poland',
    'Portugal': 'Portugal',
    'Republic of Ireland': 'Republic of Ireland',
    'Russia': 'Russia',
    'Spain': 'Spain',
    'Sweden': 'Sweden',
    'Switzerland': 'Switzerland',
    'Ukraine': 'Ukraine',
    'Uruguay': 'Uruguay',
    //Basketball US Teams
    'Boston': 'Boston',
    'Cleveland': 'Cleveland',
    'Houston': 'Houston',
    'Los Angeles': 'Los Angeles',
    'Orlando': 'Orlando',
    'Portland': 'Portland',
    'San Antonio': 'San Antonio',
    //Basketball Euro Teams
    'Euro Arena': 'Euro Arena',
    'Athens': 'Athens',
    'Real': 'Real',
    'Piraeus': 'Piraeus',
    'Istanbul Blues': 'Istanbul Blues',
    'Fener': 'Fener',
    'Vitoria': 'Vitoria',
    'Tel Aviv Yellows': 'Tel Aviv Yellows',
    'Moscow': 'Moscow',
    'Kaunas': 'Kaunas',
    'Barcelona City': 'Barcelona City',
    'Belgrade': 'Belgrade',
    'Lyon': 'Lyon',
    'Khimki': 'Khimki',
    'Berlin': 'Berlin',
    'St Petersburg': 'St Petersburg',
    'Valencia': 'Valencia',
    //Euro 2020 teams
    'Turkey': 'Turkey',
    'Netherlands': 'Netherlands',
    //Super league
    'Utd': 'Utd',
    'City': 'City',
    'Liverpool': 'Liverpool',
    'Barcelona': 'Barcelona',
    'Madrid': 'Madrid',
    'Munich': 'Munich',
    'Turin': 'Turin',
    'Milan': 'Milan',
    'Amsterdam': 'Amsterdam',
    'Paris': 'Paris',
    //NFLA
    'Pittsburgh': 'Pittsburgh',
    'Philadelphia': 'Philadelphia',
    'Denver': 'Denver',
    'New York': 'New York',
    'New England': 'New England',
    'Green Bay': 'Green Bay',
    'San Francisco': 'San Francisco',
    'Miami': 'Miami',
    'Dallas': 'Dallas',
    'Oakland': 'Oakland',
    'Chicago': 'Chicago',
    // market specific words
    'DRAW': 'Draw',
    'HD': '{0}/Draw',
    'DA': 'Draw/{1}',
    'HA': '{0}/{1}',
    'Under 2.5': 'Under 2.5',
    'Over 2.5': 'Over 2.5',
    'Under 1.5': 'Under 1.5',
    'Over 1.5': 'Over 1.5',
    'Under': 'Under {0}',
    'Over': 'Over {0}',
    'HOME': '{0}',
    'AWAY': '{1}',
    'Under 0.5': 'Under 0.5',
    'Over 0.5': 'Over 0.5',
    'Under 3.5': 'Under 3.5',
    'Over 3.5': 'Over 3.5',
    'Both Score Yes': 'Yes',
    'Both Score No': 'No',
    'Home Not to Score': '{0} Not to Score',
    'Home Exactly 1': '{0} Exactly 1',
    'Home Exactly 2': '{0} Exactly 2',
    'Home Exactly 3': '{0} Exactly 3',
    'Home Exactly 4': '{0} Exactly 4',
    'Away Not to Score': '{1} Not to Score',
    'Away Exactly 1': '{1} Exactly 1',
    'Away Exactly 2': '{1} Exactly 2',
    'Away Exactly 3': '{1} Exactly 3',
    'Away Exactly 4': '{1} Exactly 4',
    'Home to Win and both teams to score': '{0} to Win and both teams to score',
    'Home to Win to nil': '{0} to Win to nil',
    'Score draw': 'Score draw',
    '0-0': '0-0',
    '0-1': '0-1',
    '0-2': '0-2',
    '0-3': '0-3',
    '0-4': '0-4',
    '0-5': '0-5',
    '0-6': '0-6',
    '1-0': '1-0',
    '2-0': '2-0',
    '3-0': '3-0',
    '4-0': '4-0',
    '5-0': '5-0',
    '6-0': '6-0',
    '1-1': '1-1',
    '2-2': '2-2',
    '3-3': '3-3',
    '2-1': '2-1',
    '1-2': '1-2',
    '3-1': '3-1',
    '1-3': '1-3',
    '3-2': '3-2',
    '2-3': '2-3',
    '4-1': '4-1',
    '1-4': '1-4',
    '4-2': '4-2',
    '2-4': '2-4',
    '5-1': '5-1',
    '1-5': '1-5',
    '1-0,2-0,2-1': '1-0,2-0,2-1',
    '3-0,3-1,4-0': '3-0,3-1,4-0',
    '1-1,2-2': '1-1,2-2',
    '0-1,0-2,1-2': '0-1,0-2,1-2',
    '0-3,1-3,0-4': '0-3,1-3,0-4',
    'Away to Win and both teams to score': '{1} to Win and both teams to score',
    'Away to Win to nil': '{1} to Win to nil',
    'Home Win By Exactly 1 Goal': '{0} Win By Exactly 1 Goal',
    'Home Win By Exactly 2 Goals': '{0} Win By Exactly 2 Goals',
    'Home Win By 3 or more goals': '{0} Win By 3 or more goals',
    'Away Win By Exactly 1 Goal': '{1} Win By Exactly 1 Goal',
    'Away Win By Exactly 2 Goals': '{1} Win By Exactly 2 Goals',
    'Away Win By 3 or more goals': '{1} Win By 3 or more goals',
    'Draw With No Goals': 'Draw With No Goals',
    'Draw With Goals': 'Draw With Goals',
    'Any Other': 'Any Other',
    'Home Not To Score': '{0} Not To Score',
    'Home To Score': '{0} To Score',
    'Away Not To Score': '{1} Not To Score',
    'Away To Score': '{1} To Score',
    'Home': '{0}',
    'No Goal': 'No Goal',
    'Away': '{1}',
    'Home/Home': '{0}/{0}',
    'Home/Draw': '{0}/Draw',
    'Home/Away': '{0}/{1}',
    'Draw/Home': 'Draw/{0}',
    'Draw/Draw': 'Draw/Draw',
    'Draw/Away': 'Draw/{1}',
    'Away/Home': '{1}/{0}',
    'Away/Draw': '{1}/Draw',
    'Away/Away': '{1}/{1}',
    'Home and 1-0': '{0} and 1-0',
    'Home and 2-0': '{0} and 2-0',
    'Home and 2-1': '{0} and 2-1',
    'Away and 2-1': '{1} and 2-1',
    'Home and 3-0': '{0} and 3-0',
    'Home and 3-1': '{0} and 3-1',
    'Away and 3-1': '{1} and 3-1',
    'Home and 4-0': '{0} and 4-0',
    'Home and 1-1': '{0} and 1-1',
    'Away and 1-1': '{1} and 1-1',
    'Home and 2-2': '{0} and 2-2',
    'Away and 2-2': '{1} and 2-2',
    'Away and 0-1': '{1} and 0-1',
    'Away and 0-2': '{1} and 0-2',
    'Away and 1-2': '{1} and 1-2',
    'Home and 1-2': '{0} and 1-2',
    'Away and 0-3': '{1} and 0-3',
    'Away and 1-3': '{1} and 1-3',
    'Home and 1-3': '{0} and 1-3',
    'Away and 0-4': '{1} and 0-4',
    'Other': 'Other',
    'Draw': 'Draw',
    // Basketball
    '120-124': '120-124',
    '125-129': '125-129',
    '130-134': '130-134',
    '135-139': '135-139',
    '140-144': '140-144',
    '145-149': '145-149',
    '150-154': '150-154',
    '155-159': '155-159',
    '160-164': '160-164',
    '165-169': '165-169',
    '170-174': '170-174',
    '175-179': '175-179',
    'Under 180': 'Under 180',
    '180-184': '180-184',
    '185-189': '185-189',
    '190-194': '190-194',
    '195-199': '195-199',
    '200-204': '200-204',
    '205-209': '205-209',
    '210-214': '210-214',
    '215-219': '215-219',
    '220-224': '220-224',
    '225-229': '225-229',
    '230-234': '230-234',
    '235-239': '235-239',
    '240-244': '240-244',
    '245-249': '245-249',
    'Over 249': 'Over 249',
    //American Football
    '26-30': '26-30',
    '31-35': '31-35',
    '36-40': '36-40',
    '41-45': '41-45',
    '46-50': '46-50',
    '25 And Under': 'Under 26',
    '25 And Under Short': 'Under 26',
    '51 And Over': 'Over 50',
    '51 And Over Short': 'Over 50',
    'and': '&',
    'slash': '/',
    // first down
    FIRST_PLAY: '1st Play',
    SECOND_PLAY: '2nd Play',
    THIRD_PLAY: '3rd Play',
    FOURTH_PLAY: '4th Play',
    FIFTH_PLAY: '5th or More Play',
    FIELD_GOAL: 'Field Goal',
    'PassTD on 1st Play': 'PassTD on 1st Play',
    'PassTD on 2nd Play': 'PassTD on 2nd Play',
    'PassTD on 3rd Play': 'PassTD on 3rd Play',
    'PassTD on 4th Play': 'PassTD on 4th Play',
    'PassTD on or after 5th Play': 'PassTD on or after 5th Play',
    'RunTD on 1st Play': 'RunTD on 1st Play',
    'RunTD on 2nd Play': 'RunTD on 2nd Play',
    'RunTD on 3rd Play': 'RunTD on 3rd Play',
    'RunTD on 4th Play': 'RunTD on 4th Play',
    'RunTD on or after 5th Play': 'RunTD on or after 5th Play',
    'Turnover on 1st Play': 'Turnover on 1st Play',
    'Turnover on 2nd Play': 'Turnover on 2nd Play',
    'Turnover on 3rd Play': 'Turnover on 3rd Play',
    'Turnover on 4th Play': 'Turnover on 4th Play',
    'Turnover on or after 5th Play': 'Turnover on or after 5th Play',
    'Field Goal': 'Field Goal',

    //Game Tabs
    'Football': 'Football',
    'Matchday': 'Matchday',
    'Basketball': 'Basketball',
    'Dogs': 'Dogs',
    'Motor Racing': 'Motor Racing',
    'Results': 'Results',
    'Horses': 'Horses',
    'Soccer': 'Soccer',
    'US Football': 'US Football',
    'Marble Racing': 'Marble Racing',
    "Matchday_English": "Matchday",
    "Matchday_Turkish": "Matchday",
    "Matchday_Greek": "Matchday",

    //Game SubTabs
    'Soccer_Euro': 'Euro',
    'Soccer_Soccer3_Super_League': 'Super League',
    'Soccer_Soccer3_Greek_League': 'Greek League',
    'Soccer_Super_League': 'Super League',
    'Soccer_World_Cup': 'World Cup',
    'Soccer_Soccer3_World_Cup': 'World Cup',
    'Horses_Sprints': 'Sprints',
    'Horses_Flats': 'Flats',
    'Horses_Jumps': 'Jumps',
    'Basketball_US1': 'US',
    'Basketball_US2': 'US2',
    'Basketball_Europe': 'Euro',
    'Dogs_Flats': 'Flats',
    'Dogs_City': 'Static Odds',
    'Motor_Racing_Stock_Cars': 'Stock Cars',
    'Motor_Racing_Indy_Cars': 'Indy Cars',
    'US_Football_NFLA': 'NFLA',
    'US_Football_Football': 'Football',
    'Marble_Racing_Marbles': 'Marbles',
    'Marble_Racing_Marbles2': 'Sand',
    'Marble_Racing_Marbles_Euro': 'Euro Marbles',
    'Marble_Racing_Marbles_Halloween': 'Halloween',
    "Matchday_English_Matchday_English": "Matchday",
    "Matchday_Turkish_Matchday_Turkish": "Matchday",
    "Matchday_Greek_Matchday_Greek": "Matchday",

    //Racing
    FORECAST: 'Forecast',
    TRICAST: 'Tricast',
    REVERSE_FORECAST: 'Combination Forecast',
    REVERSE_TRICAST: 'Combination Tricast',
    FIRST_ST: '1',
    SECOND_ND: '2',
    THIRD_RD: '3',
    RD: 'rd',
    ST: 'st',
    ND: 'nd',
    ANY: 'Any',
    TO_WIN: 'To Win',
    RACE_CARD: 'RACECARD',
    EACH_WAY: 'Each-Way',
    EW: 'E/W',
    FORECAST_TRICAST: 'Forecast/Tricast',
    EACH_WAY_ODDS_PLACE: 'E/W {0} 1-2',
    EACH_WAY_ODDS_SHOW: 'E/W {0} 1-2-3',
    EXPAND_ALL: 'Expand Markets',
    COLLAPSE_ALL: 'Collapse Markets',
    NUMBER: 'Number',
    SORT_BY: 'Sort By',
    BET_SLIP: 'Bet Slip',
    CLOSE_BET_SLIP: 'Close',
    CLOSE_SLIP: 'Close',
    PLACED_BETS: 'Placed',
    SETTLED_BETS: 'Settled',
    SLIP: 'Slip',
    OPEN_BETS: 'Open',
    CLEAR_SELECTIONS: 'Clear Selections',
    ADD_TO_BET_SLIP: 'Add to Bet Slip',
    NO_BETS: 'No Bets',
    COMBINATION_TRICAST: 'Combination Tricast',
    COMBINATION_FORECAST: 'Combination Forecast',
    TOTAL_STAKE: 'Total Stake',
    TOTAL_POTENTIAL_RETURNS: 'Total Potential Returns',
    N_A: 'N/A',
    PLACE_BETS: 'Place Bets',
    REMOVE_ALL: 'Remove All',
    POT_RETURNS: 'Pot. Return:',
    RETURNED: 'Returned:',
    REFUNDED: 'Refunded',
    OK: 'OK',
    WIN_INITIAL: 'W',
    DRAW_INITIAL: 'D',
    LOSE_INITIAL: 'L',

    //Settings
    SETTINGS: 'Settings',
    LANGUAGE: 'Language',
    LAYOUT: 'Layout',
    ODDS: 'Odds',
    EN_GB: 'English UK',
    DECIMAL: 'Decimal',
    FRACTIONAL: 'Fractional',
    AMERICAN: 'American',
    SIMPLIFIED_DESKTOP: 'This is The main class for the desktop simplified UI',
    SIMPLIFIED_MOBILE: 'This is The main class for the mobile simplified UI',
    SHOW_VIDEO: 'Show Video',

    //Notifications
    ALERT_NOTIFICATION: 'Alert',
    WARNING_NOTIFICATION: 'Warning',
    WARNING_NOTIFICATION_REALITY_CHECK: 'Warning',
    INFO_NOTIFICATION: 'INFORMATION',
    SUCCESS_NOTIFICATION: 'Success',

    SELECTION_REMOVAL: 'This selection will be removed in ',
    SECONDS: ' seconds',
    SECOND: ' second',
    REMOVE_CLOSED_EVENTS: 'Remove Closed Events',
    SET_VIDEO_ON_FUL_SCREEN: 'Set Video on Full Screen?',
    CANCEL: 'Cancel',

    //Error codes
    INTERNAL_ERROR: 'Internal Error',
    OPEN_BETS_WARNING: 'Some or all open bets could not be added to the game card because they belong to past events.',
    '-32602': 'One or more bets were not committed on time.',
    OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED: 'The maximum number of bets on the slip bet tab has been reached. Please remove or place bets before adding new ones.',

    '-20000': 'Cannot establish connection (Error Code: -20000)', //INIT_NOT_INVOKED
    '-20001': 'Cannot establish connection (Error Code: -20001)', //MISSING_SESSION_TOKEN
    '-20002': 'Too many requests (Error Code: -20002)', //Duplicate single shot invocation
    '-20003': 'Too many requests (Error Code: -20003)', //INVOCATION_FREQUENCY_THRESHOLD_BREACHED
    '-20004': 'Invalid Request (Error Code: -20004)', //A BmsServerAPI command was received, but the params are not compliant with Operator rules.
    '-10000': 'Invalid Request (Error Code: -10000)', //INVALID_SESSION_TOKEN
    '-10001': 'Invalid Request (Error Code: -10001)', //INBOUND_MESSAGE_QUEUE_FULL
    '-1000': 'The game has been suspended. Please contact customer support.',
    '-999': 'Session expired.',
    '-998': 'Player Suspended',
    '-997': 'Command not permitted',
    '-996': 'Error processing request (Error Code: -996)', //Gaming System Error
    '-995': 'Error processing request (Error Code: -995)', //BMS Internal Error
    '-994': 'Connection lost with server, bet not placed.',
    '-980': 'Error processing request (Error Code: -980)', //Error processing game command.
    '-979': 'Error processing request (Error Code: -979)', //Error on Json message sent by Virgo.
    '-978': 'There are insufficient funds to perform this transaction.',
    '-977': 'Reality check failed.',
    '-976': 'Wallet operation temporarily blocked.',
    '-975': 'Wager limit exceeded.',
    '-974': 'Loss limit exceeded.',
    '-973': 'No limit set.',
    '-972': 'Responsible gambling error.',
    '-971': 'Wallet operation failed.',
    '-970': 'Wallet transaction rejected.',
    '-969': 'Wallet communication error.',
    '-968': 'Wallet transaction error.',
    '-967': 'Failed authentication.',
    '-966': 'High win threshold exceeded.',
    '-965': 'Invalid parameters passed.',

    // BET LIMITS ALERTS
    BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'One or more bets stake are not valid. Min stake: {0}, Max stake: {1}. Please fix this before placing your bets.',
    BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE: 'One or more bets potential returns exceed the max payout of {0} . Please fix this before placing your bets.',
    BET_NON_DIVISIBLE_MESSAGE: 'One or more bets not divisible by {0} . Please fix this before placing your bets.',
    SINGLE_BET_COMMIT_MESSAGE: 'You cannot place multiple single bets',
    REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'The bet(s) you are placing are over {0}.',
    REALITY_CHECK_WARNING_MESSAGE_LINE_2: 'Is this OK',
    REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING: 'The maximum amount of {0} has been staked. Please select a different event',

    //SIMPLIFIED UI
    TOTAL_BETS: 'TOTAL BET:',
    PLACE_YOUR_BETS: 'Place your Bets',
    RACE_START: 'Race Start',
    RACE_START_TIME: 'Start Time',
    BET_SUMMARY: 'Bet Summary',
    NO_BETS_RESUME: 'No bets were made for the current event',
    LIVE: 'LIVE',
    RACERS: 'Racers',
    SELECTION: 'Selection',
    DATE_LOCATION: 'Event',
    STAKE: 'Stake',
    BET_TYPE_STAKE: 'Bet Type / Stake',
    POTENTIAL_RETURNS: 'Pot. Returns',
    BET_HISTORY: 'Bet History',
    BET_HISTORY_LABEL: 'For further history, click Bet History button',
    FILTER_WINS: 'Filter Wins',
    NEXT_RACE: 'Next Race',
    WIN: 'Win',
    PLACE: 'Place',
    SHOW: 'Show',
    EXACTA: 'Forecast',
    TRIFECTA: 'Tricast',
    NO_WIN: 'NO WIN',
    WON: 'WON',
    LOST: 'LOST',
    CURRENT_RACE: 'Current Race',
    BOX: 'BOX',
    TO: 'to',
    PAYS: 'pays',
    TRIFECTA_BOX: 'combination tricast',
    EXACTA_BOX: 'combination forecast',
    FINISH_YOUR_BETS: 'Finish your bets',
    SELECT_YOUR_BET_BELOW: 'Select Your Bet Below',
    BET: 'bet',
    REMOVED: 'removed',
    RESULT: 'Result',
    GOALS: 'Goals',
    NO_MORE_BETS: 'No More Bets',
    EVENT_LIVE_MSG_LINE_1: 'Current Event Live',
    EVENT_LIVE_MSG_LINE_2: 'Select From Future ',
    EVENT_LIVE_MSG_LINE_3: 'Events Above',
    NO_FUTURE_EVENTS: 'No Future Events',
    AUTHENTICATION_REQUIRED: 'Please Login To Continue',
    GAME_DISABLED: 'Game Disabled',
    GAME_DISABLED_MESSAGE: 'Please contact customer support.',
    VOIDED: 'VOIDED',
    HELP: 'Help',
    LAST_RESULTS: 'Last Results',
    NO_LAST_RESULTS: 'No Last Results',
    PREVIOUS_RESULTS: 'Previous Results',
    OFFENSE_PREVIOUS_RESULTS: 'Offense Previous Results',
    DEFENSE_PREVIOUS_RESULTS: 'Defense Previous Results',
    NO_LUCK: 'NO LUCK',
    THIS_TIME: 'THIS TIME',
    LOOK_FOR_THE_NEXT: 'Look for the next',
    SCHEDULED_EVENT: 'scheduled event',
    LOOK_FOR_THE: 'Look for the',
    NEXT_SCHEDULED: 'next scheduled',
    EVENT: 'event',
    RETURNS: 'RETURNS',
    NEXT: 'Next',
    FUTURE: 'Future',
    PLAYING: 'Playing',
    //MESSAGE BAR
    ON: 'on',
    MB_RACE_ON: 'on',
    MB_RACE_WIN: 'to win',
    MB_RACE_PLACE: 'to place',
    MB_RACE_SHOW: 'to show',
    MB_RACE_TRIFECTA_BOX: 'combination tricast',
    MB_RACE_EXACTA_BOX: 'combination forecast',
    MB_RACE_EXACTA: 'forecast',
    MB_RACE_TRIFECTA: 'tricast',
    MB_FOOTBALL_ON: 'on',

    // DESKTOP UI
    ADVERTISING_SPACE: 'ADVERTISING SPACE',
    CLEAR_LAST: 'Clear Last',
    CLEAR_ALL: 'Clear All',
    ACTIVE_BETS: 'Active Bets',
    ONLY_SHOW_WINS: 'Only show wins',
    MORE: 'More',
    BETS: 'Bets',
    LOADING: 'Loading',
    BET_SELECTION_MESSAGE: 'Make your selection(s) by clicking on the odds.',

    // BUTTONS
    SIMPLE: 'simple',
    EXOTIC: 'exotic',
    UNDO: 'undo',
    CLEAR: 'clear',
    HISTORY: 'history',

    MARKETS: 'Markets',
    MAIN: 'Main',
    VS: 'vs',
    AT: '@',
    SCORE: 'score',
    DEFENDS: '(Defends) at',
    ATTACKS: '(Attacks) at',
    DETAILS: 'Details',
    NO_GOALS: 'No goals',

    MAX_WINNINGS_REACHED: 'Max Winnings Reached',
    MAX_WINNINGS_REACHED_TEXT: 'The current bet will exceed the max payout of {0}. Max Stake value permitted for this bet is {1}.',
    NO_CONNECTION_TITLE: 'Connection Lost',
    NO_CONNECTION_TITLE_TEXT: 'Connection lost with server, please ensure you have a stable network connection and refresh the page. If the problem persists, contact support.',
    PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT: 'Connection closed, user connected twice.',
    BET_CONFIRMED_TEXT: 'none',
    TAX_NOTIFICATION_TEXT: 'none',
    //Event title names
    //Football
    'THE MANOR GROUND': 'Berners Stadium',
    'METRO STADIUM': 'Metro Stadium',

    //Horses Sprints
    'HorsesSprints': 'Wetmore Sprints',
    'Showell Park': 'Showell Park',
    '2FurlongHorses': 'Wetmore Sprints',
    'Sandringham Flats': 'Sandringham Flats',
    'Princess Parkway': 'Princess Parkway',

    //Horses Jumps
    'HorsesJumps': 'Inspired Downs',


    //BasketBall
    'Virtual Arena': 'Virtual Arena',
    'Inspired Arena': 'Inspired Arena',

    //Dogs
    'DogFlat': 'Barking Green',
    'Dogs2': 'Barking Green',
    'Victoria Park': 'Victoria Park',
    'Jennison Stadium': 'Jennison Stadium',

    //Motor Racing
    'Circuit': 'Circuit',

    //Speedway Park
    'Speedway Park': 'Inspired Raceway',
    'Auto Raceway': 'Auto Raceway',

    'NO_CONNECTION_TO_VIRGO': 'Connection was lost',
    'NO_CONNECTION_TO_VIRGO_TEXT': 'Please refresh the page and login.',
    'BROWSER_NOT_SUPPORTED_DETAILS': 'Your current browser is not supported. Please use one of the following browsers: Chrome, Firefox or Safari.',
    'BROWSER_NOT_SUPPORTED': 'Browser Not Supported',
    'DOWNLOAD_CHROME': 'Download Chrome',
    'DOWNLOAD_FIREFOX': 'Download Firefox',
    'v': 'V',
    '1': '1',
    'x': 'x',
    '2': '2',
    'at': '@',
    '+10.5': '+10.5',
    '+15.5': '+15.5',
    '+5.5': '+5.5',
    '-10.5': '-10.5',
    '-15.5': '-15.5',
    '-5.5': '-5.5',
    'Over 219.5': 'Over 219.5',
    'Under 219.5': 'Under 219.5',
    'Over 214.5': 'Over 214.5',
    'Under 214.5': 'Under 214.5',
    'Over 209.5': 'Over 209.5',
    'Under 209.5': 'Under 209.5',
    'Over 144.5': 'Over 144.5',
    'Under 144.5': 'Under 144.5',
    'Over 149.5': 'Over 149.5',
    'Under 149.5': 'Under 149.5',
    'Over 154.5': 'Over 154.5',
    'Under 154.5': 'Under 154.5',
    'Over 159.5': 'Over 159.5',
    'Under 159.5': 'Under 159.5',
    'Over 164.5': 'Over 164.5',
    'Under 164.5': 'Under 164.5',
    'Rolling Downs': 'Rolling Downs',
    'FINISHING_ORDER': 'Finishing Order',
    'FORECAST_MARBLE': 'Top 2',
    'TRICAST_MARBLE': 'Top 3',
    'REVERSE_FORECAST_MARBLE': 'Top 2 Any Order',
    'REVERSE_TRICAST_MARBLE': 'Top 3 Any Order',
    'TO_WIN_MARBLE': 'Win',
    'PLACE_MARBLE': 'Place',
    'SHOW_MARBLE': 'Show',
    'MARBLE': 'Marble',
    'Rumble Turns': 'Rumble Turns',
    'Maple Downs': 'Maple Downs',

    //Header
    'BALANCE': 'Balance',
    'DATE_FORMAT': 'DD/MM/YYYY HH:mm',
    'WINS_THE_GAME': 'Wins The Game',
    'Any': 'Any',
    //Matchday
    "betSlip_Matchday_English": "Matchday English",
    "betSlip_Matchday_Turkish": "Matchday Turkish",
    "betSlip_Matchday_Greek": "Matchday Greek",
    "betSlip_Soccer": "Soccer",
    "betSlip_Horses": "Horses",
    "betSlip_Basketball": "Basketball",
    "betSlip_Dogs": "Dogs",
    "betSlip_Motor Racing": "Motor Racing",
    "betSlip_US Football": "US Football",
    "betSlip_Marble Racing": "Marble Racing",
    "POS": "pos",
    "TEAM": "team",
    "P": "p",
    "W": "w",
    "D": "d",
    "L": "l",
    "F": "f",
    "A": "a",
    "PTS": "pts",
    "LEAGUE TABLE": "league table",
    "TREND": "trend",

    //Matchday English Teams
    "Matchday_Islington": "ISL",
    "Matchday_City": "CTY",
    "Matchday_Palace": "PAL",
    "Matchday_Chelsea": "CHE",
    "Matchday_Southampton": "SOU",
    "Matchday_Wolverhampton": "WOL",
    "Matchday_Sheffield": "SHE",
    "Matchday_Leicester": "LEI",
    "Matchday_Newcastle": "NEW",
    "Matchday_Tottenham": "TOT",
    "Matchday_West Ham": "WHA",
    "Matchday_United": "UTD",
    "Matchday_Leeds": "LEE",
    "Matchday_Liverpool": "LIV",
    "Matchday_Everton": "EVE",
    "Matchday_Aston": "AST",

    //Matchday Turkish Teams
    "Matchday_Basaksehir": "BAS",
    "Matchday_Trabzon": "TRZ",
    "Matchday_Besiktas": "BKS",
    "Matchday_Sivas": "SIV",
    "Matchday_Alanya": "ALA",
    "Matchday_Galata": "GLS",
    "Matchday_Fenerbahce": "FRB",
    "Matchday_Gazientep": "GAZ",
    "Matchday_Antalya": "ANT",
    "Matchday_Kasimpasa": "KAS",
    "Matchday_Goztepe": "GOZ",
    "Matchday_Gencler": "ESK",
    "Matchday_Konya": "BUR",
    "Matchday_Rize": "RIZ",
    "Matchday_Malatya": "MAL",
    "Matchday_Kayseri": "KAY",

    //Matchday Greek Teams
    "Matchday_Dikefalos Vora": "ΔΙΚ",
    "Matchday_Erithrolefkoi": "ΘΡΥ",
    "Matchday_Enosi": "ΕΝΩ",
    "Matchday_Peristeri": "ΠΕΡ",
    "Matchday_Prasinoi": "ΠΡΑ",
    "Matchday_Kitrinoi Vora": "ΚΙΤ",
    "Matchday_Nea Smirni": "ΣΜΥ",
    "Matchday_Xanthi": "ΞΑΝ",
    "Matchday_Tripoli": "ΤΡΙ",
    "Matchday_Agrinio": "ΑΓΡ",
    "Matchday_Larisa": "ΛΑΡ",
    "Matchday_Lamia": "ΛΑΜ",
    "Matchday_Ioannina": "ΙΩΑ",
    "Matchday_Iraklio": "ΗΡΑ",
    "Matchday_A.O. Rizoupolis": "ΡΙΖ",
    "Matchday_Volos": "ΒΟΛ",

//Soccer3 Greek Teams
    "Dikefalos Vora": "ΔΙΚ",
    "Erithrolefkoi": "ΘΡΥ",
    "Enosi": "ΕΝΩ",
    "Peristeri": "ΠΕΡ",
    "Prasinoi": "ΠΡΑ",
    "Kitrinoi Vora": "ΚΙΤ",
    "Nea Smirni": "ΣΜΥ",
    "Xanthi": "ΞΑΝ",
    "Tripoli": "ΤΡΙ",
    "Agrinio": "ΑΓΡ",
    "Larisa": "ΛΑΡ",
    "Lamia": "ΛΑΜ",
    "Ioannina": "ΙΩΑ",
    "Iraklio": "ΗΡΑ",
    "A.O. Rizoupolis": "ΡΙΖ",
    "Volos": "ΒΟΛ",

    "Dortmund": "Dortmund",
    "Chelsea": "Chelsea",
    "Porto": "Porto",
    "Rome": "Rome",
    "Benfica": "Benfica",
    "Celtic": "Celtic",
    "United": "United",
    UNDER_OVER_MATCHDAY: 'Over/Under',
    UNDER_OVER_05_SHORT: "0.5",
    UNDER_OVER_25_SHORT: "2.5",
    UNDER_OVER_35_SHORT: "3.5",
    UNDER_OVER_15_SHORT: "1.5",
    UNDER_SHORT: "U",
    OVER_SHORT: "O",

    "FULL TIME": "FULL TIME",
    "FT": "FT",
    "System": "SYSTEM",
    "x1": "(x1)",
    "Multiplier": "Repeat Bet",
    "Main markets": "MAIN MARKETS",
    "8RANDOM": "8 RANDOM",
    "8FAVS": "8 FAVS",
    "QUICK_SELECT": "QUICK SELECT",
    "UNDER": "UNDER",
    "OVER": "OVER",
    "UNDER_OVER_2_5": "Over/Under 2.5",
    "UNDER_OVER_3_5": "Over/Under 3.5",
    "MATCH_RESULT": "MATCH RESULT",
    "YES": "YES",
    "NO": "NO",
    "REALITY_CHECK_WARNING_YES": "Yes",
    "REALITY_CHECK_WARNING_NO": "No",
    "ACCUMULATOR": "Accumulator",
    "+1G": "+1G",
    "Single": "Single",
    "Doubles": "Double(s)",
    "Trebles": "Treble(s)",
    "Four Folds": "4 Fold(s)",
    "Five Folds": "5 Fold(s)",
    "Six Folds": "6 Fold(s)",
    "Seven Folds": "7 Fold(s)",
    "Eight Folds": "8 Fold(s)",
    "MD": "MD{0}",
    "MATCH": "Match",
    "INVALID_ACCA": "Where selections appear highlighted your multiple selections are restricted",
    "INVALID_ODDS": "Odds value is too high. Please alter your selections",
    "INVALID_ACCA_MORETHAN_8": "Multiple bets can’t contain more than 8 selections from within a single Match",

    // Accumulator Boost
    "ACCUMULATOR_BOOST": 'Accumulator Boost',
    "ACCUMULATOR_INFO": 'If your Accumulator bet is successful a bonus of {0}% - {1}% is added to your returns. The bonus amount is dependent on the number of selections.',
    "BET_TYPE": 'Bet Type',
    "BOOST": 'Boost',
    "Bonus_Info": " {0}% Bonus",
    "+": "+",
    "Bonus_Value": "Incl {0} Bonus",
    "BOOST_PERCENTAGE": '{0}%',
    "BOOST_BONUS_START": '{0} or more selection accumulator will receive a bonus',
    "BOOST_BONUS_UPGRADE": 'Add another accumulator selection to recieve an additional bonus',
    "BOOST_BONUS_MAX": 'You have the maximum accumulator bonus',
    "Marbles_Euro_1": "Belgium",
    "Marbles_Euro_2": "Croatia",
    "Marbles_Euro_3": "Denmark",
    "Marbles_Euro_4": "England",
    "Marbles_Euro_5": "France",
    "Marbles_Euro_6": "Germany",
    "Marbles_Euro_7": "Italy",
    "Marbles_Euro_8": "Netherlands",
    "Marbles_Euro_9": "Portugal",
    "Marbles_Euro_10": "Spain",
    "Short_Over": "Over {0}",
    "Short_Under": "Under {0}",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1": "Please register or log in to place a bet",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2": " ",
    "DEMOPLAY_NOTIFICATION_DISMISS": "Dismiss",
    "DEMOPLAY_NOTIFICATION_OK": "OK",
    "Matchday_Moroccan": "Journée",
    "Matchday_Moroccan_Matchday_Moroccan": "Journée",
    "betSlip_Matchday_Moroccan": "Journée",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds": "WYD",
    "Matchday_Casa Greens": "RAJ",
    "Matchday_Fès": "FES",
    "Matchday_El Jadida": "ELJ",
    "Matchday_Berkane": "BKN",
    "Matchday_Feth": "FTH",
    "Matchday_FARabat": "FAR",
    "Matchday_Mohammedia": "MOH",
    "Matchday_Soualem": "SLM",
    "Matchday_Khouribga": "KHO",
    "Matchday_Tanger": "TAN",
    "Matchday_Agadir": "AGA",
    "Matchday_Berrechid": "BER",
    "Matchday_Oujda": "OUJ",
    "Matchday_Safi": "SAF",
    "Matchday_Oued Zem": "ODZ",
    "Matchday_Tétouan": "TET",
    "Matchday_Touarga": "TRG",
    "Matchday_Beni Mellal": "BNM",
    "Matchday_Stade Maroc": "STM",
    "Matchday_Zemamra": "ZMR",

    "Soccer_Soccer3_Moroccan_League": "Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds": "Casa Reds",
    "Casa Greens": "Casa Greens",
    "Fès": "Fès",
    "El Jadida": "El Jadida",
    "Berkane": "Berkane",
    "Feth": "Feth",
    "FARabat": "FARabat",
    "Mohammedia": "Mohammedia",
    "Soualem": "Soualem",
    "Khouribga": "Khouribga",
    "Tanger": "Tanger",
    "Agadir": "Agadir",
    "Berrechid": "Berrechid",
    "Oujda": "Oujda",
    "Safi": "Safi",
    "Oued Zem": "Oued Zem",
    "Tétouan": "Tétouan",
    "Touarga": "Touarga",
    "Beni Mellal": "Beni Mellal",
    "Stade Maroc": "Stade Maroc",
    "Zemamra": "Zemamra",
    "QUICK_FILL": "Quick Fill",
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Matchday",
    "Matchday_Belgium_Matchday_Belgium": "Matchday",
    "betSlip_Matchday_Belgium": "Matchday Belgium",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading" :"A GIFT FOR YOU",
    "Gift_for_You_Content": "Congratulations! You have promotional offers to redeem.",
    "View_Offers" : "VIEW OFFERS",
    "Do_Not_Show_MSG": "DO NOT SHOW AGAIN",
    "MY_OFFERS" : 'MY OFFERS',
    "SELECT_OFFER" : 'SELECT YOUR OFFER',
    "NO_OFFER" : 'THERE ARE NO ACTIVE OFFERS',
    "CHOOSE_BET": 'CHOOSE BET',
    "Opt_In": 'OPT IN',
    "Key_Terms_Heading" :"KEY TERMS",
    "No_Thanks" : "NO THANKS",
    "PROMO_BET": 'PROMO BET',
    "Time_To_Bet": "TIME TO BET",
    "OPTED_IN_MSG": "THANKS, YOU HAVE OPTED IN",
    "EXP": "Exp.",
    "SELECT": "Select",
    "DEMO_SITE_PROMO_NOT_AVAILABLE": "This demo site does not currently offer any promos. Please log in/register to access current offers. !",
    "Horses_US_Horses": "USA",

    //cricket
    "Cricket" : "Cricket",
    "Cricket_International": "International",
    "betSlip_Cricket": "Cricket",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":"Tie",
    //cricket markets
     "MATCH_WINNER":"Match Winner",
     "TOTAL_SIXES_IN_MATCH":"Total Match 6's",
     "TOTAL_SIXES_IN_MATCH_SHORT": "Under 1.5",
     "TOTAL_FOUR_IN_MATCH":"Total Match 4's",
     "TOTAL_BOUNDARIES_IN_MATCH":"Total Match Boundaries",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Total Runs",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"{0} Runs Off First Delivery",
     "FIRST_TEAM_WICKET_LOST":"{0} Wicket Lost",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE": "{0} First Wicket",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} Runs Off First Delivery (O/U)",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} Runs Off First Delivery (O/U)",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} Runs Off First Delivery (O/U)",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} Runs Off First Delivery (O/U)",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} Runs Off First Delivery (O/U)",
     "Caught" : "Caught",
     "Bowled":"Bowled",
     "LBW":"LBW",
     "No Wicket":"No Wicket",
     "OverZeroPointFive": "Over 0.5",
     "UnderZeroPointFive": "Under 0.5",
     "OverOnePointFive": "Over 1.5",
     "UnderOnePointFive": "Under 1.5",
     "OverTwoPointFive": "Over 2.5",
     "UnderTwoPointFive": "Under 2.5",
     "OverThreePointFive": "Over 3.5",
     "UnderThreePointFive": "Under 3.5",
     "Yes": "Yes",
     "No":"No",
     "FINAL_SCORE":"Final Score",
     OVER_145: 'Over 14.5',
     UNDER_145: 'Under 14.5',
     DRAW_Cricket: "DRAW",
      //TENNIS
    TOTAL_POINTS:"Total Points",
    HANDICAP_TENNIS: "Handicap",
    Scotland :"Scotland",
    USA: "USA",
    Tennis_International: "International",
    betSlip_Tennis: "Tennis",
    "Win By 2 or 3": "Win by 3 Points Or Less",
    "Win By 4 or 5": "Win by 4 or 5 Points",
    "Win By 6 or 7": "Win By 6 or 7 Points",
    "Tennis": "Tennis",
   //baseball
    WINNER : "WINNER",
    TOTAL_HOME_RUNS_UNDER_OVER: "TOTAL HOME RUNS 0/U",
    TOTAL_HOME_RUNS:  "TOTAL HOME RUNS EXACT",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"WINNER & TOTAL HOME RUNS O/U 5.5",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"Winner & Total HR O/U 5.5",
    BATTER1_HOME_RUNS: "{0} HOME RUNS",
    BATTER2_HOME_RUNS: "{1} HOME RUNS",
    Baseball_HR_ShootOut_Legends: "Home Runs Shootout-Legends",
    Baseball_HR_ShootOut_Legends_SHORT: "HR Shootout",
    "Baseball": "Baseball",
    "betSlip_Baseball": "Baseball",
    "Player 1 AND OVER_5_5":"{0} & Over 5.5",
    "Player 2 AND OVER_5_5":"{0} & Over 5.5",
    "Player 1 AND UNDER_5_5":"{0} & Under 5.5",
    "Player 2 AND UNDER_5_5":"{0} & Under 5.5",
    "Draw AND OVER_5_5":"Tie & Over 5.5",
    "Draw AND UNDER_5_5":"Tie & Under 5.5",
    "HOME RUNS":"{0} Home Runs"
};


// WEBPACK FOOTER //
// ./src/localization/pt_PT.js